import { useInterview } from '@/react-query/interview/interview'
import { useIsViewOnlyMember } from '@/react-query/team'
import { Toolbox } from '@/views/screens/Interview/components/FullTranscript/Toolbox/Toolbox'
import { TranscriptDisplay } from '@/views/screens/Interview/components/FullTranscript/TranscriptDisplay'
import { useAudioRecorder } from '@/views/screens/Interview/context/AudioRecorderContext/AudioRecorderContext'

export const InputTranscript = () => {
  const interview = useInterview().data
  const { isRecording } = useAudioRecorder()
  const isViewOnlyUser = useIsViewOnlyMember()

  const shouldShowToolbox =
    !isViewOnlyUser &&
    (!interview?.recallStatus || interview?.transcriptionError)
  const shouldShowTranscript =
    interview?.fullTranscript ||
    interview?.recallStatus ||
    interview?.transcriptionError ||
    isRecording

  return (
    <>
      {shouldShowToolbox && <Toolbox />}
      {shouldShowTranscript && <TranscriptDisplay />}
    </>
  )
}
